import { MapPinned, UserCheck, Car, BedDouble, Compass, Headset, LifeBuoy, CloudSun, Receipt, RefreshCw, Camera, UtensilsCrossed, Map, Wallet, HeartHandshake } from "lucide-react";

// Shared USP data — edit here to update both the homepage section and the deep-dive page.
export const USPS = [
  {
    icon: MapPinned,
    title: "Your Kashmir Trip, Designed by Locals",
    text: "Not a ready-made itinerary — a Kashmir experience designed around you.",
    long: "Every trip starts with a conversation, not a brochure. Our planners know the valley first-hand and shape each day around your pace, interests and comfort — whether that means an extra morning by Dal Lake or skipping a stop entirely.",
  },
  {
    icon: UserCheck,
    title: "Someone You Know in Kashmir",
    text: "Our team is on the ground when you need us.",
    long: "From the moment you land, you have a local point of contact. Our team is on the ground in Kashmir — reachable, accountable and ready to help in person when you need us, not just over a distant helpline.",
  },
  {
    icon: Car,
    title: "Your Driver. Your Trip. Your Comfort.",
    text: "Reliable local drivers who know Kashmir beyond the usual tourist routes.",
    long: "Your driver is your quiet co-pilot for the whole journey. We work with reliable local drivers who know the mountain roads, the honest viewpoints and the Kashmir that lies beyond the usual tourist routes.",
  },
  {
    icon: BedDouble,
    title: "We Don't Just Book Hotels. We Know Them.",
    text: "Hotels personally evaluated for location, comfort and traveller experience.",
    long: "We don't sell stays we've only seen in photos. Hotels are personally evaluated for location, comfort, cleanliness and how they treat travellers — so the room you check into matches the experience we promised.",
  },
  {
    icon: Compass,
    title: "No Cookie-Cutter Kashmir",
    text: "Because your Kashmir holiday shouldn't look like everyone else's.",
    long: "Two travellers can visit the same valley and come home with completely different stories. That's the point. Your Kashmir holiday shouldn't look like everyone else's — and with us, it doesn't.",
  },
  {
    icon: Headset,
    title: "One Trip Expert. Planning to Homecoming.",
    text: "Speak to one travel expert throughout your journey — no being passed around.",
    long: "From your first enquiry to your flight home, you deal with one travel expert who knows your file, your preferences and your plan. No repeating yourself, no being passed between departments.",
  },
  {
    icon: LifeBuoy,
    title: "Kashmir SOS Support",
    text: "If something goes wrong during your trip, you have someone local to call.",
    long: "Mountains come with surprises. If something goes wrong during your trip — a sudden change, a missed connection, a worry at an odd hour — you have someone local to call who can actually act.",
  },
  {
    icon: CloudSun,
    title: "We Plan for the Unexpected",
    text: "Weather, road conditions or last-minute changes? We'll help you adapt your itinerary.",
    long: "Weather and road conditions are part of travelling in the Himalayas. When they shift, we help you adapt — reshuffling days, swapping routes or adjusting stays so your holiday keeps moving. We promise assistance and itinerary support, not miracles.",
  },
  {
    icon: Receipt,
    title: "Know What You're Paying For",
    text: "Transparent packages with clear inclusions, exclusions and hotel options.",
    long: "Every quote lists inclusions, exclusions and hotel options in plain language. You'll always know exactly what your money buys before you pay — and what it doesn't. No vague 'best price' talk, just clarity.",
  },
  {
    icon: RefreshCw,
    title: "Change Your Plan, Not Your Holiday",
    text: "Need to adjust your itinerary? We'll help you find the best available alternative.",
    long: "Plans change; holidays shouldn't be cancelled because of it. Need to shift dates or adjust the itinerary? We'll help you find the best available alternative and make the change as painless as possible.",
  },
  {
    icon: Camera,
    title: "Take Kashmir Home With You",
    text: "Professionally captured holiday moments, arranged where operationally feasible.",
    long: "Some moments deserve more than a hurried phone photo. Where operationally feasible, we arrange professionally captured holiday moments through our local team — a few edited frames you'll actually want to frame.",
  },
  {
    icon: UtensilsCrossed,
    title: "Don't Just See Kashmir. Taste Kashmir.",
    text: "Wazwan, kahwa, local bakeries — authentic Kashmiri food experiences in your itinerary.",
    long: "A Kashmir trip that skips the food misses half the story. We weave authentic tastes into your itinerary — a Wazwan experience, noon chai and kahwa, a stop at a traditional bakery — so you taste the valley too.",
  },
  {
    icon: Map,
    title: "Beyond Srinagar–Gulmarg–Pahalgam",
    text: "We've got Kashmir beyond the usual itinerary — lesser-known valleys and experiences.",
    long: "Srinagar, Gulmarg and Pahalgam are just the beginning. When time and season allow, we open up the Kashmir most itineraries skip — the meadows of Doodhpathri, the pines of Yusmarg, the remote beauty of Gurez Valley.",
  },
  {
    icon: Wallet,
    title: "Tell Us Your Budget. We'll Build the Trip.",
    text: "₹15K, ₹20K or ₹30K — tell us your budget and we'll build the best Kashmir experience possible.",
    long: "₹15K, ₹20K or ₹30K — every honest budget can build a beautiful Kashmir trip. Tell us yours and we'll design the best experience it can buy, instead of pushing a package you don't need.",
  },
  {
    icon: HeartHandshake,
    title: "Couples Get a Different Kashmir. Families Get Another.",
    text: "We don't sell the same itinerary to everyone.",
    long: "A honeymoon needs silence and sunsets; a family trip needs comfort and timing; a friends' trip needs a little adventure. We don't sell the same itinerary to everyone — your trip is shaped by who is travelling.",
  },
];
